import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { InputField } from './InputField';
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { showToast } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { selectUserInformations } from '../../features/authSlice';
import Loader from '../Live/Loader';

const StudentItems = ({
    field,
    formData,
    type,
    handleChange,
    disabled = false,
    studentsNotInCourse = false,
    courseId = null
}) => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);

    const user = useSelector(selectUserInformations);

    // Create a function to compute params based on the type and accountType
    const getParams = useCallback(() => {
        if (studentsNotInCourse) {
            return {
                page: 1,
                search: "",
                studentsAreNotEnrolledInCourse: courseId,
            };
        } else {
            return {
                page: 1,
                search: "",
            };
        }
    }, [studentsNotInCourse]);

    // Fetch users based on computed parameters
    const fetchStudents = useCallback(async () => {
        try {
            const response = await axios.get(API.Students.app_students_all, {
                params: getParams(),
                headers: { Authorization: `Bearer ${user.token}` },
            });
            const data = response.data;

            if (data.status === 200 && data.errorCode === 0) {
                setStudents(data.data.items);
            } else {
                showToast("Error", "Failed to fetch users", "error");
            }
        } catch (error) {
            showToast(
                "Error",
                error.response?.data?.message || "An error occurred",
                "error"
            );
        }
    }, [user.token, getParams]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchStudents();
            setLoading(false);
        };
        fetchData();
    }, [fetchStudents]);

    const options = useMemo(
        () =>
            students.map((item) => ({
                id: item.id,
                name: `${item.first_name} ${item.last_name}`,
            })),
        [students]
    );

    return (
        <div>
            {/* Optionally, you can show a loading indicator if needed */}
            {loading && <div><Loader /></div>}
            <InputField
                key={field.name}
                label={field.label}
                name={field.name}
                type={field.type}
                placeholder={field.placeholder}
                value={formData[field.name]}
                handleChange={handleChange}
                options={options}
                disabled={disabled}

            />
        </div>
    );
};

export default StudentItems;
